import { schema } from "normalizr";
export const actionSchema = new schema.Entity("action", undefined, {
  idAttribute: "key"
});
export const actionGroup = new schema.Array(actionSchema);
export const actionValues = new schema.Values(actionGroup);
export const triggerSchema = new schema.Entity("trigger", undefined, {
  idAttribute: "key"
});
export const automationSchema = new schema.Entity("automation", {
  trigger: triggerSchema,
  action: actionSchema
});
export const automationDataSchema = new schema.Object({
  actions: actionValues,
  triggers: [triggerSchema],
  automations: [automationSchema]
});
export const documentRequestAutomationsSchema = new schema.Entity("documentRequestAutomations");
const documentRequestAutomationsDefinitionOption = new schema.Entity("option", {}, {
  idAttribute: "value"
});
const documentRequestAutomationsDefinitionArgument = new schema.Entity("argument", {
  options: [documentRequestAutomationsDefinitionOption]
}, {
  idAttribute: "key"
});
export const documentRequestAutomationsDefinitionSchema = new schema.Entity("rules", {
  args: [documentRequestAutomationsDefinitionArgument]
}, {
  idAttribute: "key"
});